import { useContext, useEffect } from 'react';
import { useAtom, useSetAtom } from 'jotai';
import { IAppToolsContext, BuildInAppToolId } from '../types/appTools';
import AppToolsContext from '../context/AppToolsContext';
import { EnabledAppToolsForSessionAtom, SelectedAppToolAtom } from '../atoms/appToolsAtom';

const prioritizedSessionTools = [BuildInAppToolId.SessionChats, BuildInAppToolId.SessionExtension];

const useDefaultAppTool = () => {
    const { sessionId } = useContext<IAppToolsContext>(AppToolsContext);
    const setSelectedApp = useSetAtom(SelectedAppToolAtom);
    const [tools] = useAtom(EnabledAppToolsForSessionAtom);

    useEffect(() => {
        if (sessionId) {
            const firstEnabledSessionTool = prioritizedSessionTools.find(
                toolId => tools[toolId] === true
            );
            if (firstEnabledSessionTool) {
                setSelectedApp(firstEnabledSessionTool);
            }
        }
    }, [sessionId, tools]);
};

export default useDefaultAppTool;
